import '../App.css';
import '../css/ImageGrid.css'

import { Tooltip } from "react-tooltip";
import { getuserDailylookList } from '../network/get_userDailylookList';
import React, { useState, useEffect, useRef, useCallback } from 'react';

import InfiniteScroll from 'react-infinite-scroll-component';

import Slider from 'react-slick';
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css"; 

import { useSearchParams, useNavigate } from 'react-router-dom';

import { MdArrowBackIos, MdOutlineIosShare } from "react-icons/md";

import { getUserProfile } from '../network/get_userprofile';

import { getMyfollowing } from '../network/get_myfollowing';

import { getMyfollower } from '../network/get_myfollower';

import { loginPost } from '../network/login';

import { profileUpdate, MY_URL } from '../client';

import dayjs from 'dayjs';
// dayjs 플러그인 가져오기
import relativeTime from 'dayjs/plugin/relativeTime';
// 한국어 로케일(locale) 가져오기
import 'dayjs/locale/ko'; 

import ImagePopup from '../components/ImagePopup';

// 플러그인 사용 설정
dayjs.extend(relativeTime); 
// 언어를 한국어(ko)로 설정
dayjs.locale('ko'); 

const BASE_URL = 'http://52.79.160.172:8001';
const PAGE_SIZE = 10; // 한 번에 가져올 항목 수

// ... (기존 import 및 dayjs 설정)

function Mypage() {

    const [user, setUser] = useState(null)
    // API 호출을 통해 받은 원본 응답 객체 (팔로워 수 등을 포함)

    const savedToken = localStorage.getItem('user');
            const storedUserObject = JSON.parse(savedToken);
    const [profileData, setProfileData] = useState(null); 
    const [searchParams] = useSearchParams();
    const userId = storedUserObject.id;
      const [posts, setPosts] = useState([]);
        const [hasMore, setHasMore] = useState(true);
          const [isLoading, setIsLoading] = useState(false);
            const [pageKey, setPageKey] = useState(0);

    // 팔로우 목록 관련 상태 추가
    const [showFollowingModal, setShowFollowingModal] = useState(false);
    const [followingUsers, setFollowingUsers] = useState([]);
    const [followingPageKey, setFollowingPageKey] = useState(0);
    const [followingHasMore, setFollowingHasMore] = useState(true);
    const [followingIsLoading, setFollowingIsLoading] = useState(false);


    const [showFollowerModal, setShowFollowerModal] = useState(false);
    const [followerUsers, setFollowerUsers] = useState([]);
    const [followerPageKey, setFollowerPageKey] = useState(0);
    const [followerHasMore, setFollowerHasMore] = useState(true);
    const [followerIsLoading, setFollowerIsLoading] = useState(false);

    const [showDropdown, setShowDropdown] = useState(false);

        const [isPopupOpen, setIsPopupOpen] = useState(false);

            const FALLBACK_IMAGE_URL = 'https://modii-media2.s3.ap-northeast-2.amazonaws.com/tempprofile.png';


            const BADGE_IMAGE_MAP = {
    '디렉터': 'https://modii-media2.s3.ap-northeast-2.amazonaws.com/director_badge.png',
    '플래티넘': 'https://modii-media2.s3.ap-northeast-2.amazonaws.com/plat_badge.png',
    '골드': 'https://modii-media2.s3.ap-northeast-2.amazonaws.com/gold_badge.png',
    '실버': 'https://modii-media2.s3.ap-northeast-2.amazonaws.com/silver_badge.png',
    // 뉴비는 여기에 포함하지 않음
};

const getBadgeImageSrc = (sense) => {
    return BADGE_IMAGE_MAP[sense] || null; // 일치하는 것이 없으면 null 반환
};
   
    const navigate = useNavigate();

    const handleImageError = (e) => {
        console.log('error!')
    // 이미 한 번 대체 이미지로 변경되었는데도 또 에러가 나면 무한 루프에 빠질 수 있으므로 방지
    if (e.target.src !== FALLBACK_IMAGE_URL) {
      e.target.src = FALLBACK_IMAGE_URL;
    }
  };

  const handleClosePopup = () => {
        setIsPopupOpen(false);
    };

  const handleLogout = async () => {
    // 1. 토큰 삭제
    localStorage.removeItem('user');
await loginPost("temp", "temp_user")
    
    // 2. 드롭다운 닫기
    setShowDropdown(false);
    
    // 3. 로그인 페이지로 리디렉션
    navigate('/'); 
    
};

function ShareButton({ linkToCopy }) {
  // 1. 토스트 메시지 표시 상태 관리
  const [showToast, setShowToast] = useState(false);

  // 2. 복사 및 알림을 처리하는 단일 함수
  const handleCopy = async () => {
    if (!linkToCopy) {
      console.error("복사할 링크가 없습니다.");
      return;
    }

    try {
      // ⭐️ 클립보드 API를 사용하여 링크 복사
      await navigator.clipboard.writeText(linkToCopy);

      // ⭐️ 복사 성공 시 토스트 메시지 표시
      setShowToast(true);

      // ⭐️ 일정 시간 후 토스트 메시지 숨김
      setTimeout(() => {
        setShowToast(false);
      }, 2000);

    } catch (err) {
      console.error('클립보드 복사 실패:', err);
      alert('클립보드 복사에 실패했습니다. 브라우저 권한을 확인해주세요.');
    }
  };

  return (
    <div style={{
        flex: 1, // 버튼이 공간을 균등하게 나누어 가집니다 (1:1 비율)
        padding: '12px 0',
        backgroundColor: '#f8f8f8', // 이미지의 밝은 회색 배경
        color: '#333',
        border: 'none',
        borderRadius: '10px', // 둥근 모서리
        fontSize: '16px',
        fontWeight: 'bold',
        cursor: 'pointer',
        transition: 'background-color 0.1s',
        textAlign:'center'
    }}>

         <button style={{        
        
        backgroundColor: '#f8f8f8', // 이미지의 밝은 회색 배경
        color: '#333',
        border: 'none',
        borderRadius: '10px', // 둥근 모서리
        fontSize: '16px',
        fontWeight: 'bold',
        cursor: 'pointer',
        transition: 'background-color 0.1s',}} onClick={() => handleCopy(linkToCopy)}>
                            프로필 공유
                        </button>


      {/* ⭐️ 토스트 메시지 (조건부 렌더링) */}
      {showToast && (
        <div style={styles.toast}>
          링크를 복사했습니다. ✅
        </div>
      )}
    </div>
  );
}


const toggleDropdown = () => {
    setShowDropdown(prev => !prev);
};

     

      const goToPostDetail = (postId, postCategory) => {
    // 쿼리 파라미터 형태로 인자 구성: ?id=123&category=fashion
    const queryParams = new URLSearchParams({
      id: postId,
      category: postCategory
    }).toString();

    // /detail 경로로 인자를 포함하여 GET 방식으로 이동
    navigate(`/dailylook?${queryParams}`);
  };

    // 🚨 Critical fix: await를 사용하여 Promise의 결과를 기다려야 합니다.
    async function processData() {
        try {
                await profileUpdate()

            //const savedToken = localStorage.getItem('user');
            // const storedUserObject = JSON.parse(savedToken);
            const userResponse = storedUserObject // ⭐️ await 추가
            setProfileData(userResponse);
            setUser(userResponse.profile); // 프로필 세부 정보만 user 상태에 저장
        } catch (error) {
            console.error("프로필 데이터 로드 실패:", error);
            // 사용자에게 오류 메시지를 표시하는 로직 추가 가능
        }
    }

    const fetchPosts = useCallback(async () => {

        // 주의: 함수 내부에서 최신 posts.length를 사용하지 않으므로 posts는 의존성에서 제외
        if (isLoading || !hasMore) return; // 중복 요청 방지
   
        setIsLoading(true);
       
        try {
          const response = await getuserDailylookList(
            pageKey, // 최신 pageKey 사용
            PAGE_SIZE,
            userId
          );
         
          const newPosts = response.results || [];
          const totalCount = response.total_count;
   
          // 이전 상태를 기반으로 업데이트해야 정확함
          setPosts(prevPosts => {
              const updatedPosts = [...prevPosts, ...newPosts];
             
              // *주의: posts.length 대신 updatedPosts.length를 사용해야 정확함*
              if (updatedPosts.length >= totalCount) {
                  setHasMore(false);
              }
              return updatedPosts;
          });
         
          setPageKey(prevKey => prevKey + PAGE_SIZE); // 함수형 업데이트를 사용하여 최신 pageKey 보장
         
        } catch (error) {
          console.error("데이터 로딩 실패:", error);
          setHasMore(false);
        } finally {
          setIsLoading(false);
        }
    }, [pageKey, hasMore, isLoading]);

    // 팔로우 목록 불러오기 함수
    const fetchFollowing = useCallback(async () => {
        console.log(followingIsLoading)
        console.log(!followingHasMore)
                console.log(followingIsLoading || !followingHasMore)
        if (followingIsLoading || !followingHasMore) {
            console.log("return")
            return;
        }
        setFollowingIsLoading(true);
        try {
            const response = await getMyfollowing(followingPageKey, PAGE_SIZE);
            const newUsers = response.results || [];
            const totalCount = response.count || 0; // total_count가 없을 경우 대비

            setFollowingUsers(prevUsers => {
                const updatedUsers = [...prevUsers, ...newUsers];
                if (response.next === null) {
                    setFollowingHasMore(false);
                }
                return updatedUsers;
            });

            setFollowingPageKey(prevKey => prevKey + PAGE_SIZE);
        } catch (error) {
            console.error("팔로우 목록 로드 실패:", error);
            setFollowingHasMore(false);
        } finally {
            setFollowingIsLoading(false);
        }
    }, [followingPageKey, followingHasMore, followingIsLoading]);


    const fetchFollowers = useCallback(async () => {
        if (followerIsLoading || !followerHasMore) return;

        setFollowerIsLoading(true);
        try {
            const response = await getMyfollower(followerPageKey, PAGE_SIZE);
            const newUsers = response.results || [];

            setFollowerUsers(prevUsers => {
                const updatedUsers = [...prevUsers, ...newUsers];
                if (response.next === null) {
                    setFollowerHasMore(false);
                }
                return updatedUsers;
            });

            setFollowerPageKey(prevKey => prevKey + PAGE_SIZE);
        } catch (error) {
            console.error("팔로워 목록 로드 실패:", error);
            setFollowerHasMore(false);
        } finally {
            setFollowerIsLoading(false);
        }
    }, [followerPageKey, followerHasMore, followerIsLoading]);

    useEffect(() => {
        if (userId) {
            processData();
        }
    }, [userId]);

    const goBack = () => {
        navigate(-1);
    };

        useEffect(() => {
        if (pageKey === 0 && hasMore) {
            fetchPosts();
        }
      }, []);

    // 모달 열릴 때 초기 데이터 로드
    useEffect(() => {
        if (showFollowingModal && followingPageKey === 0 && followingHasMore) {
            fetchFollowing();
        }
    }, [showFollowingModal]);

    useEffect(() => {
        if (showFollowerModal && followerPageKey === 0 && followerHasMore) {
            fetchFollowers();
        }
    }, [showFollowerModal]);

    // profileData가 없으면 로딩 중 상태 표시
    if (!profileData) {
        return <div style={{

          display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: '250px',
    }}>


      <span style={{    marginBottom: '30px',
    fontSize: '12pt'}}>불러오는 중..</span>

      <img
                              src={'loading_logo.jpg'}

                              style={{
                                width: '50px',
                                marginRight: '10px'
                                // height: '44px',
                                // borderRadius: '50%',
                                // objectFit: 'cover',
                                // marginRight: '12px',
                              }}
                            />
      

      
      </div>;
    }
   
    // API 응답에서 필요한 데이터 추출
    // const { followers, dailylook_count, username } = profileData;
    // const { thumbnail, height, body_type, fashion_sense, average_score, instagram_username } = profileData.profile;
   
    // Fashion sense 표시 문자열 조합 (예: "티어 ⓘ 플래티넘 3.93")
    const tierDisplay = `${profileData.profile.fashion_sense} ${profileData.profile.average_score}`;

    const fashionSense = profileData.profile.fashion_sense;
const badgeSrc = getBadgeImageSrc(fashionSense);
const isNewbie = fashionSense === '뉴비';

// 뱃지 이미지 스타일 (높이 유지를 위해 visibility 사용)
const imageStyle = {
    marginTop: '10px',
    height: '40px',
    display: 'block',
    // ⭐️ 뉴비일 때만 이미지를 숨기고 공간은 유지
    visibility: isNewbie ? 'hidden' : 'visible', 
};



    return (

        
        <div style={styles.mobileContainer}>
                <ImagePopup 
                isOpen={isPopupOpen} 
                onClose={handleClosePopup} 

                
            />
            <header style={styles.header}>
                <div style={styles.headerContent}>
                    <div style={styles.headerLeft}>
                        <MdArrowBackIos size="24" onClick={goBack} style={styles.iconStyle} />
                    </div>
                    <span style={styles.usernameHeader}>{profileData.username}</span>
                    <button onClick={toggleDropdown} style={styles.optionsButton}>
                        <div style={styles.dot}></div>
                        <div style={styles.dot}></div>
                        <div style={styles.dot}></div>
                    </button>
                    
                    {/* ⭐️ 3. 드롭다운 메뉴 (조건부 렌더링) */}
                    {showDropdown && (
                        <div style={styles.dropdownMenu}>
                            <button onClick={handleLogout} style={styles.dropdownItem}>
                                로그아웃
                            </button>
                        </div>
                    )}
                </div>
                <div style={styles.divider} />
            </header>

            {/* 2. 본문 (스크롤 영역) */}
            <main style={styles.mainContent}>

                {/* 3. 프로필 상단 영역 */}
                <div style={styles.profileHeader}>
                     
                    {/* 프로필 사진 및 닉네임 */}
                    <div style={styles.profileInfoRow}>
                        {/* 원형 이미지 */}
                        <div style={styles.imageWrapper}>
                            <img 
                                
                                src={profileData.profile.thumbnail ? profileData.profile.thumbnail : "https://modii-media2.s3.ap-northeast-2.amazonaws.com/tempprofile.png"}
                                 
                                style={styles.profileImage} 
                                // ⭐️ onError 이벤트 핸들러 추가
                                onError={handleImageError} 
                                />
                        </div>
                        
                        <div style={styles.textGroup}>
                            <h1 style={styles.username}>{profileData.username}</h1>
                             
                            {/* 티어 및 평균 점수 */}
                            <p style={styles.tierText}>
                                <span style={styles.tierLabel}>티어 </span>

                                <span data-tooltip-id="component-tooltip" style={styles.tierLabel}>ⓘ</span>
                                          <Tooltip id="component-tooltip" place="bottom" style={{zIndex: 100}}>
                                            <div style={{ padding: '5px' }}>
                                              <h4>등급 안내</h4>
                                              <span>{'뉴비>실버>골드>플래티넘>디렉터'}</span>
                                            </div>
                                          </Tooltip>
                                <span style={styles.tierValue}>{tierDisplay}</span>
                            </p>
                                {profileData.top_fashion_sense_percentage < 31 ?
                                <p style={styles.tierText}>
                                    <span style={styles.tierPercentage}>
                                        내 티어는 상위 {profileData.top_fashion_sense_percentage}% 입니다
                                    </span>
                                </p>
                                :
                                <></>
                                }

                        </div>
                    </div>




                    {/* 키, 체형, 인스타그램 정보 */}
                    <div style={styles.detailsRow}>
                                            {/* 티어 및 평균 점수 + 뱃지들 */}
                        <div style={styles.tierAndBadgesRow}>


                            {/* 뱃지들 (new_title 배열) */}
                            <div style={styles.badgesContainer}>

                                   
                                        <div 
                                        style={{
                                            display: 'flex',          // ⭐️ Flexbox 사용
                                            flexDirection: 'column',  // ⭐️ 아이템들을 수직으로 정렬 (이미지 위에 뱃지 텍스트)
                                            alignItems: 'center',     // ⭐️ 주 축(세로)에 대해 교차 축(가로) 중앙 정렬
                                            justifyContent: 'center', // ⭐️ 주 축(세로) 중앙 정렬 (필요시)
                                            gap: '5px'                // ⭐️ 이미지와 뱃지 텍스트 사이의 간격
                                        }}
                                    >
                                        <img 
                                    src={badgeSrc || 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7'} 
                                    alt={`${fashionSense} 뱃지`}
                                    // ⭐️ 이미지 소스가 있을 때만 표시, 없으면 투명 GIF나 빈 이미지 사용
                                    style={imageStyle} 
                                />
                                        <div
                                            
                                            style={{
                                                ...styles.badge, // 기존 뱃지 스타일 유지
                                                backgroundColor: '#dbdbdbff',
                                                color: '#b6b6b6ff',
                                                borderColor:  '#FFFFFF',
                                                fontWeight:  'bold',
                                                // 뱃지 텍스트도 Flex item이므로 추가적인 정렬 스타일 불필요
                                                textAlign: 'center' // 뱃지 텍스트 자체의 정렬 (내부 텍스트)
                                            }}
                                        >
                                            {profileData.profile.fashion_sense}
                                        </div>
                                         </div>



                                {profileData.profile.new_title?.map((badge, index) => (
                                    
                                    <div 
                                        style={{
                                            display: 'flex',          // ⭐️ Flexbox 사용
                                            flexDirection: 'column',  // ⭐️ 아이템들을 수직으로 정렬 (이미지 위에 뱃지 텍스트)
                                            alignItems: 'center',     // ⭐️ 주 축(세로)에 대해 교차 축(가로) 중앙 정렬
                                            justifyContent: 'center', // ⭐️ 주 축(세로) 중앙 정렬 (필요시)
                                            gap: '5px'                // ⭐️ 이미지와 뱃지 텍스트 사이의 간격
                                        }}
                                    >
                                        <img 
                                            src= {badge.name == '주간 모디' ? 
                                            
                                            'https://modii-media2.s3.ap-northeast-2.amazonaws.com/weekly_dailylook_badge.png' :

                                            badge.name == '월간 모디' ? 
                                            'https://modii-media2.s3.ap-northeast-2.amazonaws.com/months_dailylook_badge.png':
                                            ''
                                            }
                                            style={{
                                                marginTop : badge.name == '주간 모디' ? '10px' : '0px',
                                                height:  badge.name == '주간 모디' ? '40px' : '50px',
                                                // 이미지가 Flex item이므로 추가적인 margin: 'auto'는 필요하지 않습니다.
                                                // 하지만 너비를 'auto'로 설정하여 부모에 맞출 수도 있습니다.
                                                // width: 'auto', 
                                                // maxWidth: '100%', // 반응형을 위해 추가
                                                display: 'block' // 이미지를 블록 레벨 요소로 만들어 불필요한 공백 제거
                                            }}
                                        />
                                        {badge.name == '주간 모디' || badge.name == '월간 모디' ? 
                                        <div
                                            key={index}
                                            style={{
                                                ...styles.badge, // 기존 뱃지 스타일 유지
                                                backgroundColor: badge.background_color || '#FFEDC8',
                                                color: badge.text_color || '#FFBB31',
                                                borderColor: badge.border_color || '#FFFFFF',
                                                fontWeight: badge.is_bold_text ? 'bold' : 'normal',
                                                // 뱃지 텍스트도 Flex item이므로 추가적인 정렬 스타일 불필요
                                                textAlign: 'center' // 뱃지 텍스트 자체의 정렬 (내부 텍스트)
                                            }}
                                        >
                                            {badge.name}
                                        </div>:
                                        <></>
                                            }
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                    
                </div>

                {/* 4. 팔로우/게시물 카운트 및 팔로우 버튼 */}
                <div style={styles.statsContainer}>
                    {/* 카운트 박스 */}
                    <div style={styles.statsBox}>
                        <div style={{...styles.statItem, cursor: 'pointer'}} onClick={() => setShowFollowerModal(true)} >
                            <div style={styles.statCount}>{profileData.followers}</div>
                            <div style={styles.statLabel} >팔로워</div>
                        </div>
                        <div style={styles.statDivider}></div>
                        <div 
                            style={{...styles.statItem, cursor: 'pointer'}} 
                            onClick={() => setShowFollowingModal(true)}
                        >
                            <div style={styles.statCount}>{profileData.following}</div>
                            <div style={styles.statLabel}>팔로우</div>
                        </div>
                        <div style={styles.statDivider}></div>
                        <div style={styles.statItem}>
                            <div style={styles.statCount}>{profileData.dailylook_count}</div>
                            <div style={styles.statLabel}>게시물</div>
                        </div>
                    </div>
                     
                    {/* 팔로우 버튼 onClick={()=> navigate('/editprofile')} */}
                    <div style={styles.buttonGroup}>
                        <button style={styles.actionButton}
                        
                        onClick={() => setIsPopupOpen(true)}
                        >
                            프로필 편집
                        </button>
                        <ShareButton linkToCopy= {MY_URL + '/profile?id=' + profileData.id} />
                    </div>
                </div>

                {/* 5. 콘텐츠 그리드 영역 (임시) */}
                <div style={styles.contentGrid}>
                    <InfiniteScroll
                                    dataLength={posts.length} // 현재 로드된 항목 수
                                    next={fetchPosts}         // 스크롤이 끝에 도달하면 호출할 함수
                                    hasMore={hasMore} 
                                    scrollThreshold="60%"        // 더 불러올 데이터가 있는지 여부
                                    loader={<div></div>}
                                    endMessage={<p style={{ textAlign: 'center' }}><b>모든 결과를 불러왔습니다.</b></p>}
                                    //scrollableTarget="scrollableDiv" // 스크롤바가 있는 DOM 요소의 ID (없다면 window)
                                >
                                    <div style={styles.postsGrid}>
                     
                                    {posts.map((post, index) => (
                                      <div key={index} style={styles.postItem}>
                     
                                        <img src={post.thumbnail} alt={post.keyword} style={styles.postImage}
                                            onClick={() => goToPostDetail(post.id, 'd')}
                                       
                                        />
                                        <p>{post.description}</p>
                                      </div>
                                    ))}
                                    </div>
                                </InfiniteScroll>
                </div>

            </main>

            {/* 팔로우 목록 모달 */}
            {showFollowingModal && (
                <div style={styles.modalOverlay} onClick={(e) => e.target === e.currentTarget && setShowFollowingModal(false)}>
                    <div style={styles.modalContent}>
                        {/* 모달 헤더 */}
                        <div style={styles.modalHeader}>
                            <MdArrowBackIos 
                                size="24" 
                                onClick={() => {
                                    setShowFollowingModal(false);
                                    // 모달 닫을 때 상태 초기화 (선택적: 다음 열릴 때 새로 로드하려면)
                                    setFollowingUsers([]);
                                    setFollowingPageKey(0);
                                    setFollowingHasMore(true);
                                }} 
                                style={styles.iconStyle} 
                            />
                            <span style={styles.modalTitle}>팔로우</span>
                            <div style={{width: '24px'}} /> {/* 균형 맞추기 */}
                        </div>

                        {/* 팔로우 목록 InfiniteScroll */}
                        <div id="following-scrollable-target" style={styles.scrollableContainer}>
                        <InfiniteScroll
                            dataLength={followingUsers.length}
                            next={fetchFollowing}
                            hasMore={followingHasMore}
                            loader={<div style={styles.loader}>로딩 중...</div>}
                            endMessage={<p style={{ textAlign: 'center' }}><b>모든 팔로우를 불러왔습니다.</b></p>}
                            scrollableTarget="following-scrollable-target"
                        >
                            {followingUsers.map((user, index) => (
                                <div key={index} style={styles.userItem}>
                                    <img 
                                        src={user.profile.thumbnail || FALLBACK_IMAGE_URL} 
                                        alt={user.username} 
                                        style={styles.userImage} 
                                        onError={handleImageError}
                                    />
                                    <div style={styles.userInfo}>
                                        <span style={styles.userName}>{user.username}</span>
                                        <span style={styles.userIntro}>{user.profile.introduction || '소개 없음'}</span>
                                    </div>
                                </div>
                            ))}
                        </InfiniteScroll>
                         </div>
                    </div>
                </div>
            )}

            {showFollowerModal && (
                <div style={styles.modalOverlay} onClick={(e) => e.target === e.currentTarget && setShowFollowerModal(false)}>
                    <div style={styles.modalContent} onClick={e => e.stopPropagation()}>
                        <div style={styles.modalHeader}>
                            <MdArrowBackIos size="24" onClick={() => {
                                setShowFollowerModal(false);
                                setFollowerUsers([]);
                                setFollowerPageKey(0);
                                setFollowerHasMore(true);
                            }} style={styles.iconStyle} />
                            <span style={styles.modalTitle}>팔로워</span>
                            <div style={{width: '24px'}} />
                        </div>

                        <div id="follower-scrollable-target" style={styles.scrollableContainer}>
                            <InfiniteScroll
                                dataLength={followerUsers.length}
                                next={fetchFollowers}
                                hasMore={followerHasMore}
                                loader={<div style={styles.loader}>로딩 중...</div>}
                                endMessage={<p style={{textAlign: 'center', padding: '20px'}}><b>모든 팔로워를 불러왔습니다.</b></p>}
                                scrollableTarget="follower-scrollable-target"
                            >
                                {followerUsers.map((user, index) => (
                                    <div key={user.id || index} style={styles.userItem}>
                                        <img src={user.profile?.thumbnail || FALLBACK_IMAGE_URL} alt={user.username} style={styles.userImage} onError={handleImageError}/>
                                        <div style={styles.userInfo}>
                                            <span style={styles.userName}>{user.username}</span>
                                            <span style={styles.userIntro}>{user.profile?.introduction || '소개 없음'}</span>
                                        </div>
                                    </div>
                                ))}
                            </InfiniteScroll>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

// ----------------------------------------------------
// 스타일 정의 (모바일에 맞춤)
// ----------------------------------------------------

const styles = {
    // ----------------- 레이아웃 기본 -----------------
            toast: {
        position: 'fixed', // 화면에 고정
        bottom: '20px',    // 하단 20px 위치
        left: '50%',
        transform: 'translateX(-50%)', // 가로 중앙 정렬
        backgroundColor: 'rgba(50, 50, 50, 0.9)',
        color: 'white',
        padding: '10px 20px',
        borderRadius: '8px',
        zIndex: 9999,
        opacity: 1,
        transition: 'opacity 0.3s ease-in-out',
    },

    tierAndBadgesRow: {
    display: 'flex',
    flexDirection: 'row-reverse',
    gap: '8px',
    margin: '5px 0 0 0',
},

tierText: {
    fontSize: '14px',
    color: '#333',
    margin: 0,
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: '6px',
},

tierLabel: {
    color: '#777',
    marginRight: '5px',
},

tierValue: {
    color: '#ff4d4f',
    fontWeight: 'bold',
},

tierPercentage: {
    color: '#888',
    fontSize: '12px',
    marginLeft: '8px',
},

badgesContainer: {
    display: 'flex',
    gap: '8px',
    flexWrap: 'wrap',        // 길면 자동 줄바꿈
    marginTop: '4px',
},

badge: {
    padding: '4px 10px',
    borderRadius: '20px',
    fontSize: '12px',
    border: '2px solid',
    display: 'inline-block',
    whiteSpace: 'nowrap',
    lineHeight: '1.4',
},

    optionsWrapper: {
        position: 'relative', // 드롭다운 메뉴의 absolute 기준점
        width: '30px',
        height: '24px',
        marginRight: '10px',
    },

    // optionsButton (점 세 개)는 그대로 유지
    optionsButton: {
        // ... (기존 스타일 유지)
        position: 'absolute', // optionsWrapper를 기준으로 배치
        right: 0,
        top: 0,
    },
    
    // ⭐️ 드롭다운 메뉴 스타일 (절대 위치)
    dropdownMenu: {
        position: 'absolute',
        top: '100%', // optionsButton 바로 아래
        right: 0,     // 오른쪽 끝에 정렬
        marginTop: '10px', // 버튼과의 수직 간격
        backgroundColor: 'white',
        border: '1px solid #ddd',
        borderRadius: '8px',
        boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
        zIndex: 11, // 헤더보다 위에 표시
        minWidth: '120px',
        overflow: 'hidden',
    },
    
    // ⭐️ 드롭다운 메뉴 아이템 (로그아웃 버튼)
    dropdownItem: {
        width: '100%',
        padding: '10px 15px',
        textAlign: 'left',
        backgroundColor: 'white',
        border: 'none',
        fontSize: '15px',
        cursor: 'pointer',
        '&:hover': {
            backgroundColor: '#f0f0f0',
        },
    },


    scrollableContainer: {
    height: '100%',           // 모달 높이에 맞춤
    maxHeight: 'calc(100vh - 200px)',  // 헤더, 패딩 등을 고려한 최대 높이
    overflowY: 'auto',        // 이 요소가 스크롤됨
    paddingRight: '5px',      // 스크롤바와 컨텐츠 간격 (선택)
},

buttonGroup: {
        display: 'flex',
        gap: '8px', // 버튼 사이의 간격
        width: '100%',
        marginTop: '10px', // 통계 박스와의 간격
    },
    // ⭐️ 개별 버튼 스타일 (이미지처럼 둥글고 밝은 배경)
    actionButton: {
        flex: 1, // 버튼이 공간을 균등하게 나누어 가집니다 (1:1 비율)
        padding: '12px 0',
        backgroundColor: '#f8f8f8', // 이미지의 밝은 회색 배경
        color: '#333',
        border: 'none',
        borderRadius: '10px', // 둥근 모서리
        fontSize: '16px',
        fontWeight: 'bold',
        cursor: 'pointer',
        transition: 'background-color 0.1s',
    },

    mobileContainer: {
        maxWidth: '420px', 
        margin: '0 auto', 
        minHeight: '100vh',
    },
    loadingContainer: {
        textAlign: 'center',
        paddingTop: '100px',
        fontSize: '18px',
    },

        postsGrid: {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr 1fr', 
        gap: '1px',
    },
    postItem: {
        // border: '1px solid #eee',
        // borderRadius: '8px',
        overflow: 'hidden',
        height: '160px',
        cursor:'pointer',
        position:'relative'
    },
    postImage: {
        width: '100%',
        height: '100%',
        objectFit: 'cover',
    },
   
    // ----------------- 헤더 (고정) -----------------
    header: {
        position:'fixed',
        top:'0',
        width:'100%',
        maxWidth:'420px',
        backgroundColor:'white',
        zIndex:'10',
        paddingTop: '20px',
        boxShadow: '0 1px 2px rgba(0,0,0,0.05)',
    },
    headerContent: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '0 15px', 
    },
    headerLeft: {
        width: '30px',
    },
    usernameHeader: {
        fontSize: '18px',
        fontWeight: 'bold',
        flexGrow: 1,
        textAlign: 'center',
    },
    optionsButton: {
        width: '30px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'transparent',
        border: 'none',
        cursor: 'pointer',
        height: '24px',
    },
    dot: {
        width: '4px',
        height: '4px',
        backgroundColor: '#333',
        borderRadius: '50%',
        margin: '1px 0',
    },
    divider: {
        height: '1px', 
        backgroundColor: '#d4d4d4ff', 
        marginTop: '10px', 
    },

    // ----------------- 본문 및 프로필 -----------------
    mainContent: {
        // 고정 헤더 높이만큼 패딩 추가 (대략 60px)
        padding: '65px 15px 0 15px',
    },
    profileHeader: {
        marginBottom: '20px',
        paddingTop: '20px',
    },
    profileInfoRow: {
        display: 'flex',
        alignItems: 'center',
        marginBottom: '15px',
    },
    imageWrapper: {
        width: '80px',
        height: '80px',
        borderRadius: '50%',
        overflow: 'hidden',
        marginRight: '15px',
        flexShrink: 0,
    },
    profileImage: {
        width: '100%',
        height: '100%',
        objectFit: 'cover',
    },
    textGroup: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
    },
    username: {
        fontSize: '22px',
        fontWeight: 'bold',
        margin: '0',
    },
    tierText: {
        fontSize: '14px',
        color: '#333',
        margin: '5px 0 0 0',
    },
    tierLabel: {
        color: '#777',
        marginRight: '5px',
    },
    tierValue: {
        color: '#ff4d4f', // 이미지의 붉은색
        fontWeight: 'bold',
    },
    detailsRow: {
        display: 'flex',
        flexDirection: 'column',
        gap: '8px',
        color: '#555',
        fontSize: '15px',
        marginBottom: '20px',
    },
    detailItem: {
        display: 'flex',
        alignItems: 'center',
    },
    detailIcon: {
        marginRight: '8px',
    },
    detailText: {
        //
    },

    // ----------------- 통계 및 버튼 -----------------
    statsContainer: {
        marginBottom: '30px',
    },
    statsBox: {
        display: 'flex',
        justifyContent: 'space-around',
        alignItems: 'center',
        backgroundColor: '#f8f8f8',
        borderRadius: '10px',
        padding: '15px 0',
        marginBottom: '20px',
    },
    statItem: {
        textAlign: 'center',
        flex: 1,
    },
    statCount: {
        fontSize: '20px',
        fontWeight: 'bold',
    },
    statLabel: {
        fontSize: '12px',
        color: '#666',
    },
    statDivider: {
        width: '1px',
        height: '30px',
        backgroundColor: '#e0e0e0',
    },
    followButton: {
        width: '100%',
        padding: '15px 0',
        backgroundColor: '#ff4d4f', // 이미지의 빨간색
        color: 'white',
        border: 'none',
        borderRadius: '10px',
        fontSize: '18px',
        fontWeight: 'bold',
        cursor: 'pointer',
    },

    // ----------------- 그리드 -----------------
    contentGrid: {
       // borderTop: '1px solid #ddd',
        paddingTop: '20px',
        textAlign: 'center',
    },

    // ----------------- 모달 스타일 추가 -----------------
    modalOverlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 1000,
    },
    modalContent: {
        backgroundColor: 'white',
        width: '100%',
        maxWidth: '420px',
        height: '80%',
        //overflowY: 'auto',
        borderRadius: '10px',
        padding: '20px',
    },
    modalHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '20px',
        paddingBottom: '10px',
        borderBottom: '1px solid #ddd',
    },
    modalTitle: {
        fontSize: '18px',
        fontWeight: 'bold',
        flexGrow: 1,
        textAlign: 'center',
    },
    userItem: {
        display: 'flex',
        alignItems: 'center',
        padding: '10px 0',
        borderBottom: '1px solid #eee',
    },
    userImage: {
        width: '50px',
        height: '50px',
        borderRadius: '50%',
        objectFit: 'cover',
        marginRight: '15px',
    },
    userInfo: {
        display: 'flex',
        flexDirection: 'column',
    },
    userName: {
        fontSize: '16px',
        fontWeight: 'bold',
    },
    userIntro: {
        fontSize: '14px',
        color: '#666',
    },
    loader: {
        textAlign: 'center',
        padding: '20px',
    },
    iconStyle: {
        cursor: 'pointer',
    }
};

export default Mypage;